import React, { useEffect, useState } from 'react';

import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';
import { getIpData, getipData } from '../../api/auth';
import Navbar from '../../component/NavBar';
import Header from '../../component/Header';
import Spinner from '../../component/Spinner';

let ipTempModel = "";
let ipBgColor = "";

function IpMonitoring() {

    const { instance } = useMsal();
    const activeAccount = instance.getActiveAccount();

    const navigate = useNavigate();

    const [isShow, setIsShow] = useState(false);
    const [refresh, setRefresh] = useState(false);
    const [date, setDate] = useState('');
    const [ipData, setIpData] = useState([]);

    useEffect(() => {
        if (!activeAccount) {
            navigate("/mes");
        }
    }, [activeAccount]);

    useEffect(() => {
        (async () => {
            try {
                setIsShow(true);
                const result = await getIpData();
                console.log('result', result);
                if (result.ok === true) {
                    setDate(dayjs(result.timestamp).format('M/D/YYYY(ddd)'));
                    setIpData(result.data);
                } else {
                    alert("API CALL FAIL");
                }
            } catch (error) {
                console.log('error', error);
                alert(error.message);
            } finally {
                setIsShow(false);
            }
        })();
    }, [refresh]);

    return (
        <>
            <Spinner isShow={isShow} />
            <Header setRefresh={setRefresh} />
            <Navbar />
            <div className='p-1'>
                <div className='font-bold'>
                    IP Productivity - <span className='uppercase'>{date}</span> Shift: {ipData?.output?.SHIFT}
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">
                                    MODEL
                                </th>
                                <th scope="col" className="py-1">
                                    COLOR
                                </th>
                                <th scope="col" className="py-1">
                                    TARGET
                                </th>
                                <th scope="col" className="py-1">
                                    OUTPUT
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                ipData?.output?.results?.map((v, i) => {
                                    if (ipTempModel !== v.MODEL) {
                                        ipTempModel = v.MODEL;
                                        ipBgColor = ipBgColor === "bg-white" ? "bg-gray-100" : "bg-white"
                                    }

                                    return (
                                        <tr key={i} className={`${ipBgColor} border-b`}>
                                            <td className="py-1">
                                                {v.MODEL}
                                            </td>
                                            <td className="py-1">
                                                {v.COLOR}
                                            </td>
                                            <td className="py-1">
                                                {v.TARGET}
                                            </td>
                                            <td className="py-1">
                                                {v.OUTPUT}
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className='font-bold mt-3'>
                    IP Production Performance
                </div>
                <div className="relative overflow-x-auto">
                    <table className="w-full text-md text-center rtl:text-right text-gray-500 ">
                        <thead className="text-xs text-gray-700 uppercase bg-slate-300 ">
                            <tr>
                                <th scope="col" className="py-1">
                                    MODEL
                                </th>
                                <th scope="col" className="py-1">
                                    PLAN
                                </th>
                                <th scope="col" className="py-1">
                                    TARGET
                                </th>
                                <th scope="col" className="py-1">
                                    OUTPUT
                                </th>
                                <th scope="col" className="py-1">
                                    PF
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-black">
                            {
                                ipData?.output?.SB?.map((v, i) => {
                                    if (ipTempModel !== v.MODEL) {
                                        ipTempModel = v.MODEL;
                                        ipBgColor = ipBgColor === "bg-white" ? "bg-gray-100" : "bg-white"
                                    }

                                    return (
                                        <tr key={i} className={`${ipBgColor} border-b  `}>
                                            <td className="py-1">
                                                {v.MODEL}
                                            </td>
                                            <td className="py-1">
                                                {v.TargetSum}
                                            </td>
                                            <td className="py-1">
                                                {v.PlanPF}
                                            </td>
                                            <td className="py-1">
                                                {v.OutputSum}
                                            </td>
                                            <td className="py-1">
                                                {v.PF}%
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default IpMonitoring;
